import React from 'react';
import { XMarkIcon, Bars3Icon } from '@heroicons/react/24/outline';
import { useTranslation } from '@/store/languageStore';

interface WidgetContainerProps {
  children: React.ReactNode;
  editMode?: boolean;
  onRemove?: () => void;
  dragHandleProps?: Record<string, any>;
  /** Fyll rutnätscellen. Innehåll som inte ryms scrollar inuti kortet. */
  fill?: boolean;
  /** När fill är satt och detta är false scrollar bara innehållet som själv ber om det. */
  bodyScroll?: boolean;
  toolbar?: React.ReactNode;
}

const WidgetContainer: React.FC<WidgetContainerProps> = ({
  children,
  editMode,
  onRemove,
  dragHandleProps,
  fill,
  bodyScroll = true,
  toolbar,
}) => {
  const { t } = useTranslation();
  return (
    <div className={`dq-widget bg-bgElevated rounded-xl shadow-lg border overflow-hidden transition-all ${
      fill ? 'flex flex-col h-full min-h-0' : ''
    } ${
      editMode
        ? 'border-blue-400 dark:border-blue-600 border-dashed ring-2 ring-blue-200/50 dark:ring-blue-800/50'
        : 'border-borderDefault'
    }`}>
      {editMode && (
        <div className="flex items-center justify-between gap-2 px-3 py-1.5 bg-blue-50 dark:bg-blue-900/20 border-b border-blue-200 dark:border-blue-800 shrink-0">
          <div
            {...dragHandleProps}
            className="flex items-center gap-1.5 cursor-grab active:cursor-grabbing text-blue-500 dark:text-blue-400"
          >
            <Bars3Icon className="w-4 h-4" />
            <span className="text-xs font-medium select-none">{t('widgets.move')}</span>
          </div>
          <div className="flex items-center gap-2">
            {toolbar}
            {onRemove && (
              <button
                onClick={onRemove}
                className="p-1 rounded hover:bg-red-100 dark:hover:bg-red-900/30 text-red-400 hover:text-red-600 transition-colors"
                title={t('widgets.remove')}
              >
                <XMarkIcon className="w-4 h-4" />
              </button>
            )}
          </div>
        </div>
      )}

      <div className={`p-4 relative ${fill ? `dq-widget-body flex-1 min-h-0 ${bodyScroll ? 'overflow-auto' : 'overflow-hidden flex flex-col'}` : ''}`}>
        {!editMode && onRemove && (
          <div className="absolute top-2 right-2 z-10">
            <button
              onClick={onRemove}
              className="p-1 rounded hover:bg-red-100 dark:hover:bg-red-900/30 text-textTertiary hover:text-red-500 transition-colors opacity-30 hover:opacity-100"
              title={t('widgets.remove')}
            >
              <XMarkIcon className="w-4 h-4" />
            </button>
          </div>
        )}
        {children}
      </div>
    </div>
  );
};

export default WidgetContainer;
